export default __webpack_public_path__ + "static/media/close-up-of-stylish-composition-with-businessman-2022-12-07-04-22-55-utcArtboard-1.c120627a.jpeg";